import DataTableV2 from "components/commons/data-table/data-table-v2";
import React from "react";

const CashInList = ({ table }) => {
  return <DataTableV2 {...table} />;
};

export default CashInList;
